import { SearchableType, Term } from '../../types';

export default {
  addScope: (payload: { scope: SearchableType }) =>
    <const>{
      type: 'ADD_SCOPE',
      payload,
    },
  removeScope: (payload: { scope: SearchableType }) =>
    <const>{
      type: 'REMOVE_SCOPE',
      payload,
    },
  addParam: (payload: { terms: Term[]; scope: SearchableType }) =>
    <const>{
      type: 'ADD_PARAM',
      payload,
    },
  removeParam: (payload: { scope: SearchableType }) =>
    <const>{
      type: 'REMOVE_PARAM',
      payload,
    },
};
